import React from 'react';
import clsx from 'clsx';
import { toast } from 'react-toastify';

import { Dialog, Checkbox, ToastDialog } from '@shared/components';
import {
  getSheetData,
  getFileContent,
  mapFileContent,
  writeXLSFile,
  getShowDialogStatus,
  setShowDialogStatus,
} from '@utils';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';
import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip';

import AddIcon from '@material-ui/icons/Add';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import CloudUpload from '@material-ui/icons/CloudUpload';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import AlbumIcon from '@material-ui/icons/Album';

import UploadDialog from './upload-dialog';

import { RingCentralService } from '@consumers/services';
import useStyles from './style';

const defaultState = {
  isAssigningId: false,
  success: [],
  errors: [],
  hasPaused: false,
  isUploadingFiles: false,
  openUploadDialog: false,
  selectedFile: null,
  collapseErrorList: false,
  prefrenceChecked: false,
  isUpdating: false,
  isLoading: false,
  isDownloading: false,
  isErrorEncountered: false,
  showToastDialog: false,
  toastDialogContent: '',
  toastDialogHeading: '',
  showContentAction: false,
  isDisabling: false,
  status: '',
  isUploadDisable: false,
  isRateLimited: false,
  rateLimitDelay: 0,
};
let progress = 0;
let isPaused = false;
const noop = () => {};

const UpdateCallerId = ({
  uid = '',
  getJWKSToken = noop,
  filteredMatchingDIDInfo = [],
  extensions = [],
  setIsDisabled = () => {},
}) => {
  const classes = useStyles();
  const [state, setState] = React.useState(defaultState);

  React.useEffect(() => {
    isPaused = false;
    setState(prevState => ({
      ...prevState,
      errors: [],
      success: [],
    }));
    return () => {
      isPaused = true;
      progress = 0;
      setState(prevState => ({
        ...defaultState,
        success: [],
        errors: [],
      }));
    };
  }, []);

  const updateCallerIds = async (selectedArr, incomingDataArr) => {
    if (selectedArr.length !== incomingDataArr.length) {
      let newb = [];
      let missingArr = [];
      for (let current of selectedArr) {
        if (current.extensionNum) {
          newb.push(current.extensionNum);
        }
      }

      for (let current of incomingDataArr) {
        let missing = newb.indexOf(current.Extension);
        if (missing === -1) {
          missingArr.push({
            key: current.Extension,
            value: 'Matching number not found',
          });
        }
      }
      console.log(`Matching number not found for `, missingArr);
      setState(prevState => ({
        ...prevState,
        errors: missingArr,
      }));
      // ErrorArray = [...missingArr];
    }
    for (let current of selectedArr) {
      if (isPaused) {
        setState(prevState => ({
          ...prevState,
          isUploadDisable: false,
        }));
        break;
      }
      let callerId = await RingCentralService.getCallerIds(
        current.extId,
        uid,
        getJWKSToken(),
        rateLimit => {
          const { delay } = rateLimit;
          setState(prevState => ({
            ...prevState,
            isRateLimited: true,
            rateLimitDelay: Math.ceil(delay / 1000),
          }));
          const rateLimitDelayInterval = setInterval(() => {
            setState(prevState => {
              const rateLimitDelay =
                prevState.rateLimitDelay > 0
                  ? prevState.rateLimitDelay - 1
                  : prevState.rateLimitDelay;
              return { ...prevState, rateLimitDelay };
            });
          }, 1000);

          setTimeout(() => {
            clearInterval(rateLimitDelayInterval);
            setState(prevState => ({
              ...prevState,
              isRateLimited: false,
            }));
          }, delay);
        }
      );
      console.log(
        'Issue getting caller id for ' +
          current.extensionNum +
          ': ' +
          callerId.error
      );
      callerId = callerId.data;

      if (callerId?.byDevice) {
        for (let i in callerId.byDevice) {
          if (!callerId.byDevice[i].callerId.phoneInfo) {
            if (
              current.numId !== 'Blocked' &&
              callerId.byDevice[i].callerId.type === 'Blocked'
            ) {
              callerId.byDevice[i].callerId.type = 'PhoneNumber';
              callerId.byDevice[i].callerId.phoneInfo = {};
            } else {
              continue;
            }
          }

          if (current.numId === 'Blocked') {
            delete callerId.byDevice[i].callerId.phoneInfo;
            callerId.byDevice[i].callerId.type = 'Blocked';
          } else {
            delete callerId.byDevice[i].callerId.phoneInfo.phoneNumber;
            delete callerId.byDevice[i].callerId.phoneInfo.uri;

            callerId.byDevice[i].callerId.phoneInfo.id = current.numId;
          }
        }
      }

      for (let i in callerId?.byFeature) {
        if (callerId.byFeature[i].feature === 'Alternate') {
          continue;
        }
        if (callerId.byFeature[i].callerId.phoneInfo) {
          delete callerId.byFeature[i].callerId.phoneInfo.phoneNumber;
          delete callerId.byFeature[i].callerId.phoneInfo.uri;
        } else {
          callerId.byFeature[i].callerId.phoneInfo = {};
        }

        if (current.numId === 'Blocked') {
          delete callerId.byFeature[i].callerId.phoneInfo;
          callerId.byFeature[i].callerId.type = 'Blocked';
        } else {
          callerId.byFeature[i].callerId.type = 'PhoneNumber';
          callerId.byFeature[i].callerId.phoneInfo.id = current.numId;
        }
      }

      if (callerId?.extensionNameForOutboundCalls) {
        delete callerId.extensionNameForOutboundCalls;
      }
      if (callerId?.extensionNumberForInternalCalls) {
        delete callerId.extensionNumberForInternalCalls;
      }

      const { data, error } = await RingCentralService.updateIds(
        current.extId,
        uid,
        getJWKSToken(),
        callerId,
        rateLimit => {
          const { delay } = rateLimit;
          setState(prevState => ({
            ...prevState,
            isRateLimited: true,
            rateLimitDelay: Math.ceil(delay / 1000),
          }));
          const rateLimitDelayInterval = setInterval(() => {
            setState(prevState => {
              const rateLimitDelay =
                prevState.rateLimitDelay > 0
                  ? prevState.rateLimitDelay - 1
                  : prevState.rateLimitDelay;
              return { ...prevState, rateLimitDelay };
            });
          }, 1000);

          setTimeout(() => {
            clearInterval(rateLimitDelayInterval);
            setState(prevState => ({
              ...prevState,
              isRateLimited: false,
            }));
          }, delay);
        }
      );
      if (error) {
        toast.error(error);

        //tempError.push(current.did);

        //ErrorArray = [...tempError];

        setState(prevState => {
          let tempError = prevState.errors;
          tempError.push({
            key: current.did,
            value: error[0]?.message
              ? error[0].message
              : 'Issue in setting caller id',
          });
          return {
            ...prevState,
            errors: tempError,
            isErrorEncountered: true,
          };
        });
        console.log('Issue setting caller id for ' + current.did);
      } else {
        // let tempSuccess = state.success;
        // tempSuccess.push(current.did);

        // setState(prevState => ({
        //   ...prevState,
        //   success: tempSuccess,
        // }));
        setState(prevState => {
          let tempSuccess = prevState.success;
          tempSuccess.push(current.did);
          return {
            ...prevState,
            success: tempSuccess,
          };
        });
      }
      progress = progress + 100 / selectedArr.length;
    }
    if (!isPaused) {
      progress = 100;
      setState(prevState => ({
        ...prevState,
        showContentAction: true,
        showToastDialog: true,
        isUploadDisable: false,
        hasPaused: true,
        status: !!prevState.errors.length ? 'Error' : 'Success',
        isErrorEncountered: !!prevState.errors.length ? true : false,
        toastDialogContent: !!prevState.errors.length
          ? 'Errors detected'
          : 'Your data has been successfully updated.',
        toastDialogHeading: !!prevState.errors.length
          ? 'UPLOAD ERRROR'
          : 'SUCCESS!',
      }));
    }
  };

  const handleDownload = async () => {
    setState(prevState => ({
      ...prevState,
      isDisabling: true,
    }));
    writeXLSFile(`CallerId.xlsx`, 'Sheet1', [
      { Extension: '' },
      { Number: '' },
    ]);
  };

  const handleFileSelection = event => {
    let selectedFile = null;
    if (event.currentTarget.files && event.currentTarget.files.length > 0) {
      selectedFile = event.currentTarget.files[0];
    }
    if (!event.currentTarget.files && event.currentTarget.files.length === 0) {
      toast.error('Selected file is empty');
      return;
    }
    if (!selectedFile) {
      return;
    }
    setState(prevState => ({
      ...prevState,
      selectedFile,
    }));
  };

  //Compare the parsed numbers to the filteredMatchingDIDInfo master array and the phone numbers list,
  // and push matches into a new array with the updated information
  const matchExtensionNumbersToIds = async incomingDataArr => {
    let newArray = [];
    for (let incomingDataObj of incomingDataArr) {
      let extension = extensions.find(item => {
        return (
          item.extensionNumber == incomingDataObj.Extension.toString() &&
          item.type === 'User'
        );
      });
      if (!extension) {
        let tempError = state.errors;
        tempError.push({
          key: incomingDataObj.Extension,
          value:
            'Valid user not found for extension number' +
            incomingDataObj.Extension,
        });
        setState(prevState => ({
          ...prevState,
          errors: tempError,
        }));
        console.log(
          `Error: Valid user not found for extension number ${incomingDataObj.Extension}`
        );
        continue;
      }
      let current = filteredMatchingDIDInfo.find(item => {
        return item.did == incomingDataObj.Number;
      });
      let newCurrent = {};
      if (!current) {
        current = {
          extensionNum: incomingDataObj.Extension,
          extId: extension.id,
          deviceId: null,
        };
        if (incomingDataObj.Number === 'blocked') {
          current.numId = 'Blocked';
          newArray.push(current);
        } else {
          let tempError = state.errors;
          //tempError.push(current.did);
          tempError.push({
            key: current.extensionNum,
            value:
              'Caller ID number not found for extension' + current.extensionNum,
          });
          setState(prevState => ({
            ...prevState,
            errors: tempError,
          }));
          console.log(
            `Error: Caller ID number not found for extension ${current.extensionNum}`
          );
        }
      } else {
        newCurrent = {
          extId: extension.id,
          extensionNum: incomingDataObj.Extension,
          did: current.did,
          numId: current.numId,
          deviceId: current.deviceId,
        };
        newArray.push(newCurrent);
      }
    }
    updateCallerIds(newArray, incomingDataArr);
  };
  const handleUpload = async () => {
    const fileContent = await getFileContent(state.selectedFile, {
      header: 1,
    });

    const sheetData = getSheetData(fileContent, fileContent.SheetNames[0]);
    const incomingDataArr = mapFileContent(sheetData);

    if (!incomingDataArr || Object.keys(incomingDataArr).length === 0) {
      toast.error('Selected file is empty.');
      return;
    }
    setState(prevState => ({
      ...prevState,
      isUploadingFiles: true,
      isUploadDisable: true,
      success: [],
      errors: [],
    }));
    for (let current of incomingDataArr) {
      if (String(current.Number)?.toUpperCase() === 'BLOCKED') {
        current.Number = 'blocked';
      } else {
        let number = await current.Number?.toString();
        let formatted = number?.replace(/\D+/g, '') ?? '';
        if (formatted?.length === 10) {
          formatted = '+1' + formatted;
        } else {
          formatted = '+' + formatted;
        }
        current.Number = formatted;
      }
    }
    matchExtensionNumbersToIds(incomingDataArr);
    setState(prevState => ({
      ...prevState,
      openUploadDialog: false,
      selectedFile: null,
    }));
  };

  //Filter DID array without extensions
  const filterDIDWithoutExt = (didInfo = []) => {
    let filteredDIDInfo = [];
    for (let did of didInfo) {
      if (did.extId) {
        if (
          extensions.findIndex(item => {
            return item.id == did.extId && item.type === 'User';
          }) >= 0
        ) {
          filteredDIDInfo.push(did);
        }
      }
    }
    return filteredDIDInfo;
  };

  const renderTooltip = () => {
    return (
      <Typography variant='caption'>
        This button will change the <br />
        caller ID to the DID on file for <br /> EVERY extension and device
        <br />
        on the account.
      </Typography>
    );
  };

  React.useEffect(() => {
    setIsDisabled(
      state.isUpdating || state.isUploadingFiles || state.isDisabling
    );
  }, [state.isUpdating, state.isUploadingFiles, state.isDisabling]);

  return (
    <div>
      <Paper className='mr-10 ml-10 p-7 mt-5' elevation={2}>
        <div className='d-flex f-justify-between'>
          <div>
            <Typography variant='body1' className='text-bold'>
              Instructions:
            </Typography>
            <Typography variant='body1' className='mt-3'>
              1. Auto Assign ID or download the Excel file. <br />
              2. Update the file. <br />
              ** Column A is the extension number. Column B is the number you
              would like to set as the caller ID.
              <br /> To block the caller ID, write 'blocked' under column B.
            </Typography>
          </div>
          <div>
            {!state.isDownloading && (
              <Tooltip title={renderTooltip()} placement='top-start'>
                <Button
                  className='mr-5 bold-font'
                  variant='outlined'
                  color='primary'
                  startIcon={<AddIcon style={{ fontSize: 30 }} />}
                  onClick={event => {
                    const value = localStorage.getItem('dialog-status');
                    if (!!value) {
                      setState(prevState => ({
                        ...prevState,
                        isUpdating: true,
                        isAssigningId: false,
                      }));
                      let filteredDID = filterDIDWithoutExt(
                        filteredMatchingDIDInfo
                      );
                      updateCallerIds(filteredDID, filteredDID);
                    } else {
                      setState(prevState => {
                        return {
                          ...prevState,
                          isAssigningId: true,
                        };
                      });
                    }
                  }}
                  disabled={state.isUpdating}
                >
                  Auto Assign ID
                </Button>
              </Tooltip>
            )}
            <Button
              variant='contained'
              color='primary'
              className='bold-font'
              startIcon={<SystemUpdateAltIcon />}
              onClick={event => {
                setState(prevState => {
                  return {
                    ...prevState,
                    isDownloading: true,
                  };
                });
                handleDownload();
              }}
              disabled={state.isUpdating || state.isDisabling}
            >
              Download
            </Button>
          </div>
        </div>
        {state.isAssigningId && (
          <Dialog
            open={state.isAssigningId}
            onClose={() => {
              setState(prevState => ({
                ...prevState,
                isAssigningId: false,
              }));
            }}
            classes={{
              paper: classes.progressDialog,
            }}
          >
            <Dialog.Title hasClose />
            <Dialog.Content>
              <div className='p-2'>
                <Typography variant='h5' className='text-bold'>
                  Auto Assign Warning:
                </Typography>
                <Typography variant='body1' className='mt-8'>
                  This action will change the caller ID to DID on file for every
                  extension and device on the account.
                </Typography>
                <Typography variant='body1' className='mt-5'>
                  If the extension has multiple numbers on file, the first
                  number will be used.
                </Typography>
                <div className='d-flex f-align-center  mt-5'>
                  <Checkbox
                    className='mr-2'
                    name='preference'
                    checked={state.prefrenceChecked}
                    onChange={event => {
                      if (event.currentTarget) {
                        if (state.prefrenceChecked === false) {
                          localStorage.setItem('dialog-status', true);
                        }
                        if (state.prefrenceChecked === true) {
                          localStorage.removeItem('dialog-status');
                        }
                        setState(prevState => {
                          return {
                            ...prevState,
                            prefrenceChecked: !prevState.prefrenceChecked,
                          };
                        });
                      }
                    }}
                  />
                  <Typography variant='body1'>
                    Don't show me this message again
                  </Typography>
                </div>
              </div>
            </Dialog.Content>
            <Dialog.Actions>
              <div className='mb-6 mr-7'>
                <Button
                  onClick={() => {
                    setState(prevState => ({
                      ...prevState,
                      isAssigningId: false,
                    }));
                  }}
                  variant='outlined'
                  className='mr-6'
                >
                  Cancel
                </Button>
                <Button
                  color='primary'
                  onClick={() => {
                    setState(prevState => ({
                      ...prevState,
                      isUpdating: true,
                      isAssigningId: false,
                    }));
                    let filteredDID = filterDIDWithoutExt(
                      filteredMatchingDIDInfo
                    );
                    updateCallerIds(filteredDID, filteredDID);
                  }}
                  variant='contained'
                >
                  Update
                </Button>
              </div>
            </Dialog.Actions>
          </Dialog>
        )}
      </Paper>

      {state.isUpdating && (
        <Paper className='mr-10 ml-10 p-7 mt-5 mb-3' elevation={2}>
          <div className='d-flex f-align-center f-justify-between'>
            <div></div>
            <Typography variant='h6' className='f-align-center text-bold mt-2'>
              {!!state.errors.length
                ? 'ENCOUNTERED ERRORS'
                : 'SUCCESSFULLY UPDATED:'}
            </Typography>
            <div></div>
          </div>
          <LinearProgress
            classes={{
              barColorPrimary: !!state.errors.length
                ? classes.errorColor
                : classes.successColor,
            }}
            className={clsx('mt-10 w-100', classes.progressBar)}
            variant='determinate'
            value={progress}
          />
          <Typography variant='body2' className='color-text-secondary mt-1'>
            {`${Math.floor(progress)}%`}
          </Typography>
          {state.isRateLimited && (
            <div className='d-flex f-align-center f-justify-center mt-4'>
              <Chip
                label={`Oops! Rate limit exceeded. Download will resume in ${state.rateLimitDelay ||
                  '60'} seconds.`}
                color='primary'
                className='mr-4 mt-2 mb-2 bg-danger color-white'
              />
            </div>
          )}
          {!!state.success.length && (
            <Typography variant='body2' className='color-success mt-4'>
              {state.success.join(', ')}
            </Typography>
          )}
          {!!state.errors.length && (
            <div className={classes.overflow}>
              <Typography className='color-error'>
                There were some errors with your submission:
              </Typography>
              <Typography variant='body2' className='color-error mt-1'>
                {state.errors.map(error => (
                  <Typography variant='body2' className='color-error mt-2'>
                    {`${error.key} : ${error.value}`}
                  </Typography>
                ))}
              </Typography>
            </div>
          )}
        </Paper>
      )}

      {state.showToastDialog && (
        <ToastDialog
          open={state.showToastDialog}
          heading={state.toastDialogHeading}
          contentText={state.toastDialogContent}
          contentAction={state.showContentAction}
          isError={state.isErrorEncountered}
          status={state.status}
          onClose={() => {
            setState(prevState => ({
              ...prevState,
              showToastDialog: defaultState.showToastDialog,
            }));
          }}
        />
      )}

      {state.isDownloading && (
        <div>
          <Paper className='mr-10 ml-10 p-7 mt-5 mb-5' elevation={2}>
            <div className='d-flex f-justify-between'>
              <div>
                <Typography variant='body1' className='text-bold'>
                  File Upload
                </Typography>
                <Typography variant='body1' className='mt-3'>
                  3.Upload your edited file.
                </Typography>
              </div>
              <div className='d-flex f-justify-between'>
                <div>
                  {state.isUploadingFiles && (
                    <Button
                      variant='contained'
                      color='primary'
                      disabled={state.hasPaused}
                      className={clsx('mr-5', classes.pauseButton)}
                      onClick={() => {
                        isPaused = true;
                        setState(prevState => {
                          return {
                            ...prevState,
                            hasPaused: true,
                            isUploadDisable: false,
                          };
                        });
                      }}
                    >
                      <AlbumIcon />
                    </Button>
                  )}
                  <Button
                    className=' bold-font'
                    variant='contained'
                    color='primary'
                    startIcon={<CloudUpload />}
                    disabled={state.isUploadDisable}
                    onClick={event => {
                      setState(prevState => {
                        return {
                          ...prevState,
                          openUploadDialog: true,
                        };
                      });
                    }}
                  >
                    Upload File
                  </Button>
                </div>
              </div>
            </div>
            {state.openUploadDialog && (
              <UploadDialog
                isOpen={state.openUploadDialog}
                selectedFile={state.selectedFile}
                onClose={() => {
                  setState(prevState => ({
                    ...prevState,
                    openUploadDialog: false,
                    selectedFile: null,
                  }));
                }}
                onChange={handleFileSelection}
                handleUpload={() => {
                  progress = 0;
                  isPaused = false;
                  setState(prevState => ({
                    ...prevState,
                    errors: [],
                    success: [],
                    hasPaused: false,
                  }));
                  handleUpload();
                }}
              />
            )}

            {state.isUploadingFiles && (
              <>
                <Typography
                  variant='h6'
                  className='align-center text-bold mt-2'
                >
                  {!!state.errors.length
                    ? 'ERRORS FOUND'
                    : 'CALLER ID UPLOADING'}
                </Typography>
                <LinearProgress
                  classes={{
                    barColorPrimary: state.errors.length
                      ? classes.errorColor
                      : classes.successColor,
                  }}
                  className={clsx('mt-10 w-100', classes.progressBar)}
                  variant='determinate'
                  value={progress}
                />
                <Typography
                  variant='body2'
                  className='color-text-secondary mt-1'
                >
                  {`${Math.floor(progress)}%`}
                </Typography>
                {state.isRateLimited && (
                  <div className='d-flex f-align-center f-justify-center mt-4'>
                    <Chip
                      label={`Oops! Rate limit exceeded. Download will resume in ${state.rateLimitDelay ||
                        '60'} seconds.`}
                      color='primary'
                      className='mr-4 mt-2 mb-2 bg-danger color-white'
                    />
                  </div>
                )}
                {!!state.success.length && (
                  <div>
                    <div className='d-flex f-align-center'>
                      <Typography className='align-center text-bold mt-2'>
                        Successfully Updated:
                      </Typography>
                    </div>
                    <div className='d-flex f-align-center'>
                      <Typography
                        variant='body2'
                        className='align-left color-success mt-2'
                      >
                        {state.success.join(', ')}
                      </Typography>
                    </div>
                  </div>
                )}
                {!!state.errors.length && (
                  <div>
                    <div className='d-flex f-align-center'>
                      <Typography className='color-error text-bold'>
                        Errors Found
                      </Typography>
                      <IconButton
                        onClick={() => {
                          setState(prevState => {
                            return {
                              ...prevState,
                              collapseErrorList: !prevState.collapseErrorList,
                            };
                          });
                        }}
                      >
                        {!state.collapseErrorList ? (
                          <ArrowDropDownIcon className='color-error' />
                        ) : (
                          <ArrowDropUpIcon className='color-error' />
                        )}
                      </IconButton>
                    </div>

                    {!!state.errors.length && state.collapseErrorList && (
                      <div className={classes.overflow}>
                        <Typography className='color-error'>
                          There were some errors with your submission:
                        </Typography>
                        <Typography
                          variant='body2'
                          className='color-error mt-1'
                        >
                          {state.errors.map(error => (
                            <Typography
                              variant='body2'
                              className='color-error mt-2'
                            >
                              {`${error.key} : ${error.value}`}
                            </Typography>
                          ))}
                        </Typography>
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
          </Paper>
        </div>
      )}
    </div>
  );
};
export default UpdateCallerId;
